import { z } from 'zod';
import { Id } from './domain.js';
import { ScriptOp } from './script-ops.js';

export const ChatMessage = z.object({
  id: Id,
  reelId: Id,
  role: z.enum(['user', 'assistant']),
  text: z.string().max(4000),
  at: z.string(),
  /** Set on assistant messages that changed the script. `inverse` restores the version before. */
  change: z
    .object({
      fromVersion: z.number().int().nonnegative(),
      toVersion: z.number().int().nonnegative(),
      changed: z.array(z.string()),
      inverse: z.array(ScriptOp),
      undone: z.boolean().default(false),
    })
    .optional(),
});
export type ChatMessage = z.infer<typeof ChatMessage>;
